










































import { Component, Prop, Vue } from 'vue-property-decorator';

import IngredientList from './IngredientList.vue';
import InstructionList from './InstructionList.vue';

@Component({
  components: {
    IngredientList,
    InstructionList,
  },
})
export default class Recipe extends Vue {
  @Prop({ required: true }) readonly recipe!: any;
  @Prop(Number) readonly index: number | undefined;

  displayedVersion: Object = {};

  mounted() {
    this.displayedVersion = this.recipe.current;
  }

  get headerText() {
    if (!this.index) return this.recipe.name;

    return `${this.index}: ${this.recipe.name}`;
  }
}
